import styles from './MyTrainings.module.css';

import Figma_Logo_1x from './../../assets/HomePage/TrainingTechnologies/Figma_Logo/Figma_Logo_1x.webp';
import Figma_Logo_2x from './../../assets/HomePage/TrainingTechnologies/Figma_Logo/Figma_Logo_2x.webp';

import React_Logo_1x from './../../assets/HomePage/TrainingTechnologies/React_Logo/React_Logo_1x.webp';
import React_Logo_2x from './../../assets/HomePage/TrainingTechnologies/React_Logo/React_Logo_2x.webp';

import Angular_Logo_1x from './../../assets/HomePage/TrainingTechnologies/Angular_Logo/Angular_Logo_1x.webp';
import Angular_Logo_2x from './../../assets/HomePage/TrainingTechnologies/Angular_Logo/Angular_Logo_2x.webp';

export default function MyTrainingsComponent() {
    return (
        <section className={styles.myTrainingsSection + ' section'}>
            <div className={styles.cardHeader}>
                <h2 className={styles.sectionHeading}>My Popular Technology Training Programs</h2>
            </div>
            <div className={styles.myTrainingsContent}>
                <figure>
                    <picture>
                        <source type="image/webp" media="(min-width:300px)" srcSet={Figma_Logo_1x + ' 1x, ' + Figma_Logo_2x + ' 2x'} alt='Logo of Figma' />
                        <img src={Figma_Logo_1x} alt='Logo of Figma' />
                    </picture>
                    <figcaption className={styles.figcaption_skillLogo}>Figma</figcaption>
                </figure>
                <figure>
                    <picture>
                        <source type="image/webp" media="(min-width:300px)" srcSet={React_Logo_1x + ' 1x, ' + React_Logo_2x + ' 2x'} alt='Logo of React' />
                        <img src={React_Logo_1x} alt='Logo of React' />
                    </picture>
                    <figcaption className={styles.figcaption_skillLogo}>React</figcaption>
                </figure>
                <figure>
                    <picture>
                        <source type="image/webp" media="(min-width:300px)" srcSet={Angular_Logo_1x + ' 1x, ' + Angular_Logo_2x + ' 2x'} alt='Logo of Angular' />
                        <img src={Angular_Logo_1x} alt='Logo of Angular' />
                    </picture>
                    <figcaption className={styles.figcaption_skillLogo}>Angular</figcaption>
                </figure>
            </div>
        </section >
    );
}